// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2XYC7","paramInput":"JobSimulator_paramInput__1gnVk","input":"JobSimulator_input__3Rez5"};